export async function loadCompanyById(id) {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/public/restaurant?id=${id}`);
        if (response.ok) {
            
            return response.json();
        }
    }
    catch (error) {
        console.error(error);
    }
    return {};
}

export async function loadCompanyByName(name) {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/public/restaurant?name=${name}`);
        if (response.ok) {
            
            return response.json();
        }
    }
    catch (error) {
        console.error(error);
    }
    return {};
}
